<template>
  <div class="tr-at-a-glance">
    <h1 class="tr-at-a-glance__title">
      {{ title }}
    </h1>
    <p class="tr-at-a-glance__section">{{ section }}</p>
    <p class="tr-at-a-glance__date">Published {{ publishDate }}</p>
    <div
      class="tr-at-a-glance__table"
      v-for="(data, indexOne) in cwaData"
      :key="indexOne"
      :class="getTableClassName"
    >
      <AtAGlanceIndicatorTableHeaderRow
        :rowData="data.ColumnHeaders"
        :firstRow="true"
        :hasHighlight="hasHighlights(data)"
        :fromReport="true"
      />
      <AtAGlanceIndicatorTableRow
        v-for="(rowData, indexTwo) in data.IndicatorData"
        :key="indexTwo"
        :rowData="rowData"
        :isLastRow="indexTwo == data.IndicatorData.length - 1"
        :fromReport="true"
      />
    </div>
    <div class="tr-at-a-glance__legend">
      <AtAGlanceLegend :fromReport="true" />
    </div>
    <p class="tr-at-a-glance__notification-text" v-if="cwaData[0].Summary">
      The below transcription was pulled from this articles' video summary,
      available for viewing in your onDemand portal.
    </p>
    <div
      class="tr-at-a-glance__summary-transcription"
      v-if="cwaData[0].Summary"
    >
      <div class="tr-at-a-glance__summary-transcription__header">
        <div class="tr-at-a-glance__summary-transcription__title">
          Summary Transcription
        </div>
      </div>
      <div class="tr-at-a-glance__summary-transcription__content">
        <div
          class="tr-at-a-glance__summary-transcription__text"
          v-html="cwaData[0].Summary"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import AtAGlanceLegend from '~/components/trendsreport/html/AtAGlanceComponents/AtAGlanceLegend.vue';
  import AtAGlanceIndicatorTableRow from '~/components/trendsreport/html/AtAGlanceComponents/AtAGlanceIndicatorTableRow.vue';
  import AtAGlanceIndicatorTableHeaderRow from '~/components/trendsreport/html/AtAGlanceComponents/AtAGlanceIndicatorTableHeaderRow.vue';

  export default {
    name: 'TrAtAGlanceTemplate',
    components: {
      AtAGlanceLegend,
      AtAGlanceIndicatorTableRow,
      AtAGlanceIndicatorTableHeaderRow,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      cwaData: {
        type: Object,
        required: true,
      },
      section: {
        type: String,
        required: false,
      },
      publishDate: {
        type: String,
        required: false,
      },
    },

    setup() {},
    computed: {
      getTableClassName() {
        let hasHighlight = this.cwaData.some((rowData) =>
          rowData.IndicatorData.some((data) => !!data.Highlight)
        );
        return hasHighlight ? '' : 'no-highlights';
      },
    },
    methods: {
      hasHighlights(data) {
        if (!data) return;
        if (!data.ColumnHeaders) return;
        let highlights = false;
        if (
          data.ColumnHeaders[data.ColumnHeaders.length - 1] === 'Highlights'
        ) {
          highlights = true;
        }
        if (highlights) {
          let highlightsCount = 0;
          data.IndicatorData.forEach((rowData) => {
            if (rowData.Highlight !== '') {
              highlightsCount++;
            }
          });
          if (highlightsCount === 0) {
            highlights = false;
          }
        }
        return highlights;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tr-at-a-glance {
    page-break-inside: avoid;
    font-family: 'Open Sans', sans-serif !important;
    &__title {
      margin-bottom: 2rem;
      color: var(--itr-blue);
      font-weight: bold;
      font-size: 40px;
    }
    &__table {
      display: grid;
      grid-template-columns:
        minmax(250px, 1fr)
        98px 96px 120px 92px 92px 92px minmax(450px, 1fr);
      grid-template-rows: auto;
      overflow-x: auto;
      margin-bottom: 2rem;
      page-break-inside: avoid;
    }
    &__table.no-highlights {
      display: grid;
      grid-template-columns:
        minmax(250px, 1fr)
        98px 96px 120px 92px 92px 92px 60px;
      grid-template-rows: auto;
      overflow-x: auto;
      margin-bottom: 2rem;
      page-break-inside: avoid;
    }
    &__legend {
      page-break-inside: avoid;
      margin: 3rem 0 2rem 0;
    }
    &__section {
      color: var(--itr-blue);
      font-weight: bold;
      font-size: 26px;
    }
    &__date {
      color: var(--itr-grey-charcoal);
      font-size: 22px;
      font-style: italic;
      margin-bottom: 2rem;
    }
    &__summary-transcription {
      page-break-inside: avoid;
      width: 100%;
      margin-top: 2rem;
      &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: var(--itr-blue);
        padding: 10px 20px;
        // border-radius: 10px 10px 0 0;
      }
      &__title {
        font-weight: bold;
        font-size: 20px;
        color: var(--itr-white);
      }
      &__content {
        // border-radius: 0 0 10px 10px;
        border-left: 2px solid var(--itr-grey);
        border-right: 2px solid var(--itr-grey);
        border-bottom: 2px solid var(--itr-grey);
        padding: 16px 32px;
      }
      &__text {
        * {
          font-size: 14px !important;
          color: var(--itr-charcoal) !important;
          background-color: transparent !important;
          font-family: 'Open Sans', sans-serif !important;
        }
      }
    }
    &__notification-text {
      font-size: 16px;
      font-weight: bold;
      font-style: italic;
      margin-bottom: 1rem;
      color: var(--itr-charcoal);
    }
  }
</style>
